import React, { useEffect, useState } from 'react'
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast'
import $ from 'jquery';
import { TOAST_DURATION, TOAST_ERROR_COLOR, TOAST_POSITION, TOAST_SUCCESS_COLOR } from '../../../../../common/app_constant';
import ErrorLabel from "../../../../../component/error_label";
import Flatpickr from "react-flatpickr";
import moment from 'moment'

const AddAppointments = (props) => {

    const dispatch = useDispatch()
    const navigation = useNavigate()

    const {
        register,
        formState: { errors },
        handleSubmit,
        getValues,
        setValue,
        watch,
        reset,
        control
    } = useForm({
        defaultValues: {
            start_date: ''
        },
    });

    const [allDropdownArr, setAllDropdownArr] = useState(null)

    useEffect(() => {
        if (props.isUploadDoc === true) {
            // dispatch(actionDropdown())
            setValue('start_date','')
        }

    }, [props.isAppointments])


    // useEffect(() => {
    //     if (uploadKYCDocuments !== null) {
    //         dispatch(resetUploadKYCDocumentsResponse())
    //         if (uploadKYCDocuments.result === true) {
    //             toast.success(uploadKYCDocuments.message, {
    //                 duration: TOAST_DURATION,
    //                 position: TOAST_POSITION,
    //                 style: {
    //                     color: TOAST_SUCCESS_COLOR
    //                 }
    //             })
    //             $("#app-body").attr("style", "");
    //             $("#root").removeClass("modal-open");
    //             $(".modal-backdrop").remove();
    //             setValue('document_type')
    //             setValue('title')
    //             props.isUploadDocClose()

    //         } else {
    //             switch (uploadKYCDocuments.status_code) {

    //             }
    //         }
    //     }
    // }, [uploadKYCDocuments])


    const onSubmit = async (data) => {
    };

    return (

        <div
            className="modal fade"
            id="requestMeetingModal"
            tabIndex={-1}
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
            style={{ display: props.isAppointments === true ? 'block' : 'none' }}
        >
            <div className="modal-dialog" role="document">
                <form
                    noValidate
                    autoComplete="off"
                    onSubmit={handleSubmit(
                        onSubmit
                    )}
                >
                    <div className="modal-content">
                        <div className="modal-body ">
                            <h6 className="mt-2 text-center">Create New Meeting</h6>
                            <div className="row">
                                <div className="col-12 mt-3">
                                    <div class="form-group has-search">
                                        <label htmlFor="documentType" className="form-label">
                                            Meeting Date<span className="text-danger">*</span>
                                        </label>
                                        <span class="fa fa-calendar form-control-feedback"></span>
                                        <Controller
                                            name='start_date'
                                            control={control}
                                            render={({ field }) => (
                                                <Flatpickr
                                                    {...field}
                                                    onChange={(value) => {
                                                        var date = new Date(value).toISOString()
                                                        setValue('start_date', moment(date).format('DD-MM-YYYY'))
                                                    }}
                                                    id='disabled-picker'
                                                    className="form-control"
                                                    options={{
                                                        dateFormat: 'd-m-Y',
                                                        minDate: 'today',
                                                        enableTime: false
                                                    }}
                                                />
                                            )}
                                            rules={{
                                                required: "This is required."
                                            }}
                                        />
                                        {errors.start_date && (
                                            <ErrorLabel
                                                message={
                                                    errors
                                                        .start_date
                                                        ?.message
                                                }
                                            />
                                        )}
                                    </div>
                                </div>
                                <div className="col-12 mt-3">
                                    <label htmlFor="documentType" className="form-label">
                                        Message
                                    </label>
                                    <textarea
                                        className="form-control"
                                        id="lossLocation"
                                        rows={3}
                                        defaultValue={""}
                                    />
                                </div>
                                <div className="col-12 mt-3">
                                    <label htmlFor="documentType" className="form-label">
                                        Company Name<span className="text-danger">*</span>
                                    </label>
                                    <select id="documentType" className="form-control form-select">
                                        <option selected="">company name</option>
                                        <option>company name</option>
                                    </select>
                                </div>
                            </div>
                            <button type="submit" className="btn btn-primary btn-sm  mt-3">
                                Submit
                            </button>
                            <button
                                type="button"
                                className="btn btn-secondary btn-sm  mt-3"
                                data-bs-dismiss="modal"
                                onClick={() => {
                                    props.isClose()
                                }}
                                style={{
                                    marginLeft: 10,
                                }}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )

}

export default AddAppointments;